import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useRef, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const Tournaments = () => {
    const [tournamentId, setTournamentId] = useState(0);
    const [tournaments, setTournaments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const fileInputRef = useRef(null);

    const [formData, setFormData] = useState({
        id: 0,
        tournamentName: "",
        location: "",
        startDate: "",
        endDate: "",
        organizerName: "",
        contactNumber: "",
        emailId: "",
        totalTeams: "",
        totalMatches: "",
        description: "",
        status: "upcoming",
        match_over_type: "limited",
        total_overs: "",
        ball_type: "",
        file: null,
    });

    // ✅ Fetch all tournaments
    const fetchTournaments = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${baseurl}${API_URL.getTournaments}`);
            if (res.status === 200) {
                setTournaments(res.data?.data || []);
            }
        } catch (err) {
            toast.error("Failed to load tournaments");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTournaments();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "file"
                    ? files[0]
                    : name === "contactNumber"
                        ? value.replace(/\D/g, "")   // 🔥 allow only digits
                        : value,
        }));
    };


    // ✅ Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const fd = new FormData();
            Object.keys(formData).forEach((key) => {
                fd.append(key, formData[key]);
            });

            const res = await axios.post(`${baseurl}${API_URL.saveTournament}`, fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (res.data.isSuccess === 1) {
                toast.success(
                    tournamentId ? "Tournament updated successfully!" : "Tournament created successfully!"
                );
                setIsFormOpen(false);
                fetchTournaments();
                handleClose();
            } else {
                toast.error(res.data.message || "Failed to save tournament");
            }
        } catch (err) {
            toast.error("Error saving tournament. Please try again.");
        }
    };

    // ✅ Edit existing tournament
    // const handleEdit = (item) => {
    //     setTournamentId(item.id);
    //     setIsFormOpen(true);
    //     setFormData({
    //         ...item,
    //         cupImage: null,
    //     });
    // };

    const handleEdit = (item) => {
        setTournamentId(item.id);
        setIsFormOpen(true);

        const formatDate = (dateString) => {
            if (!dateString) return "";
            return dateString.split("T")[0]; // Extract YYYY-MM-DD
        };

        setFormData({
            ...item,
            startDate: formatDate(item.startDate),
            endDate: formatDate(item.endDate),
            cupImage: null,
        });
    };

    // ✅ Delete tournament
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this tournament?")) return;

        try {
            const res = await axios.get(`${baseurl}${API_URL.deleteTournament}?id=${id}`);
            if (res.data.isSuccess === 1) {
                toast.success("Tournament deleted successfully!");
                fetchTournaments();
            }
        } catch {
            toast.error("Error deleting tournament.");
        }
    };

    // ✅ Reset form
    const handleClose = () => {
        setIsFormOpen(false);
        setTournamentId(0);
        setFormData({
            id: 0,
            tournamentName: "",
            location: "",
            startDate: "",
            endDate: "",
            organizerName: "",
            contactNumber: "",
            emailId: "",
            totalTeams: "",
            totalMatches: "",
            description: "",
            status: "upcoming",
            match_over_type: "limited",
            total_overs: "",
            ball_type: "",
            cupImage: null,
        });
        if (fileInputRef.current) fileInputRef.current.value = "";
    };
    // matches-list
    // ✅ DataTable columns
    const columns = [
        { name: "S.No", selector: (row, i) => i + 1, width: "70px" },
        {
            name: "Tournament Name", selector: (row) => (
                <div>
                    <Link to={`/matches-list/${row?.id}`}>{row.tournamentName}</Link>
                </div>
            ),
            sortable: true,
            width: '180px'
        },
        { name: "Location", selector: (row) => row.location, sortable: true },
        {
            name: "Start Date",
            selector: (row) => {
                const date = new Date(row.startDate);
                return `${date.toISOString().split('T')[0]} (${date.toLocaleDateString('en-US', { weekday: 'long' })})`;
            },
        },
        {
            name: "End Date",
            selector: (row) => {
                const date = new Date(row.endDate);
                return `${date.toISOString().split('T')[0]} (${date.toLocaleDateString('en-US', { weekday: 'long' })})`;
            },
        },
        { name: "Match Type", selector: (row) => row.match_over_type || "-" },
        { name: "Total Overs", selector: (row) => row.total_overs || "-" },
        { name: "Ball Type", selector: (row) => row.ball_type || "-" },
        { name: "Status", selector: (row) => row.status },
        {
            name: "Action",
            cell: (row) => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span onClick={() => handleEdit(row)} title='Edit' className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#ff7722" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="#ff7722" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </span>
                    <span onClick={() => handleDelete(row?.id)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">Tournaments</h4>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="add_btn">
                            <button onClick={() => setIsFormOpen(true)}>Add Tournament</button>
                        </div>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={tournaments}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormOpen ? "open" : ""}`}>
                    <div className="closebtn">
                        <button onClick={handleClose}>
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>

                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>{tournamentId ? "Edit Tournament" : "Add Tournament"}</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label>Tournament Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="tournamentName"
                                        value={formData.tournamentName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Location</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="location"
                                        value={formData.location}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Start Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="startDate"
                                        value={formData.startDate}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>End Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="endDate"
                                        value={formData.endDate}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Organizer Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="organizerName"
                                        value={formData.organizerName}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Contact Number</label>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        name="contactNumber"
                                        value={formData.contactNumber}
                                        onChange={handleChange}
                                        pattern="[0-9]*"
                                        inputMode="numeric"
                                        maxLength={10}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Email ID</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name="emailId"
                                        value={formData.emailId}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Total Teams</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="totalTeams"
                                        value={formData.totalTeams}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Total Matches</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="totalMatches"
                                        value={formData.totalMatches}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>Match Over Type</label>
                                    <select
                                        name="match_over_type"
                                        className="form-control"
                                        value={formData.match_over_type}
                                        onChange={handleChange}
                                    >
                                        <option value="limited">Limited</option>
                                        <option value="unlimited">Unlimited</option>
                                    </select>
                                </div>

                                {formData.match_over_type === "limited" && (
                                    <div className="col-md-6">
                                        <label>Total Overs</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="total_overs"
                                            value={formData.total_overs}
                                            onChange={handleChange}
                                        />
                                    </div>
                                )}

                                <div className="col-md-6">
                                    <label>Ball Type</label>
                                    <select
                                        name="ball_type"
                                        className="form-control"
                                        value={formData.ball_type}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Tennis">Tennis</option>
                                        <option value="Leather">Leather</option>
                                        <option value="Rubber">Rubber</option>
                                    </select>
                                </div>

                                <div className="col-md-12">
                                    <label>Description</label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        rows="3"
                                        value={formData.description}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>

                                <div className="col-md-6">
                                    <label>Upload Image</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        name="file"
                                        onChange={handleChange}
                                        ref={fileInputRef}
                                    />
                                </div>
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">{tournamentId ? "Update" : "Submit"}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Tournaments;
